import React, { useState } from "react";
import { Box, TextField, Button, Typography, Alert } from "@mui/material";
import { useLanguage } from "../contexts/LanguageContext";
import { formatMessage } from "../locales";

function EmailSignup() {
  const { messages, locale } = useLanguage();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: "", message: "" });

    try {
      const response = await fetch("/api/subscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, language: locale }),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus({
          type: "success",
          message: formatMessage(messages, "emailSignup.success"),
        });
        setEmail("");
      } else {
        setStatus({
          type: "error",
          message: data.message || formatMessage(messages, "emailSignup.error"),
        });
      }
    } catch (error) {
      setStatus({
        type: "error",
        message: formatMessage(messages, "emailSignup.error"),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box
      component="section"
      sx={{
        py: 8,
        px: 2,
        backgroundColor: "background.paper",
        borderTop: 1,
        borderColor: "divider",
      }}
    >
      <Box
        sx={{
          maxWidth: 600,
          mx: "auto",
          textAlign: "center",
        }}
      >
        <Typography variant="h5" component="h2" gutterBottom>
          {formatMessage(messages, "emailSignup.title")}
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          {formatMessage(messages, "emailSignup.description")}
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TextField
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={formatMessage(messages, "emailSignup.placeholder")}
            required
            sx={{ flexGrow: 1, maxWidth: 400 }}
          />
          <Button
            type="submit"
            variant="contained"
            disabled={isSubmitting}
            sx={{ minWidth: 120 }}
          >
            {formatMessage(messages, "emailSignup.submit")}
          </Button>
        </Box>
        {status.message && (
          <Alert
            severity={status.type}
            sx={{ mt: 2, maxWidth: 400, mx: "auto" }}
          >
            {status.message}
          </Alert>
        )}
      </Box>
    </Box>
  );
}

export default EmailSignup;
